import React, { Fragment } from "react";

const ContainerLeft = ({ children }) => {
  return (
    <Fragment>
      <div className="container--left">
        {children}
      </div>
    </Fragment>
  );
};

export default ContainerLeft;



// WEBPACK FOOTER //
// ./src/components/layouts/containerLeft/containerLeft.js